import React from 'react';
import { copyToClipboard, stanAnalytics } from '@/lib';
import { StanButton } from '@/components';
import { useUser } from '@/queries/useUser';
import IcCopy from '@/assets/icons/ic-copy.svg';

interface ChatMainFeedPostProps {
    post: {
        id: number;
        content: string;
    };
}

export const ChatMainFeedPost: React.FC<ChatMainFeedPostProps> = ({ post }) => {
    const { user } = useUser();

    const cleanHtmlContent = (content: string): string => {
        const str = content.replace(/<p>/g, '').replace(/<\/p>/g, '\n').replace(/<br>/g, '\n');

        if (!str || typeof str !== 'string') return str;

        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    };

    const handleCopy = async () => {
        const cleanedContent = cleanHtmlContent(post.content);
        await copyToClipboard(cleanedContent, {
            successMessage: 'Copied to clipboard',
            errorMessage: 'Failed to copy post',
        });

        stanAnalytics('chat-v2-instagram-main-feed-post-copied', {
            meta: { user_id: user?.user_id, username: user?.username },
            props: {
                post_id: post.id,
                trigger_location: 'chat-message',
            },
        });
    };

    return (
        <div className='mt-2 flex w-full flex-col items-start gap-3'>
            <div className='body-md text-dark w-full' dangerouslySetInnerHTML={{ __html: post.content }} />
            <StanButton name='copy-marketing-post' onClick={handleCopy} color='primary' size='sm' icon={IcCopy}>
                Copy Post
            </StanButton>
        </div>
    );
};
